import { ref, watch } from 'vue';
import { cachedStoreOrders } from "./RecentOrdersStore";
import { STORE_ORDER_STATUS_OBJ } from "@lib/types/storeOrderStatus";
import { hasError } from './hasError';
import { showOrderDialog } from './OrderDialogShow';

export const isAbleToPlayAudio = ref(true);

export const playBlankAudioLoop = () => {
    const audio = document.getElementById('blank-loop') as HTMLAudioElement;
    if (audio) {
        audio.play()
            .then(() => {
                isAbleToPlayAudio.value = true;
            })
            .catch(() => {
                isAbleToPlayAudio.value = false;
                // console.warn('📣📣📣Audio permission denied📣📣📣');
                // console.error(error);
            });
    }
    // Play new order audio with volume 0 and then increase to 1 after 2 seconds
    // maybe this can warm up the tab to play audio later
    const newOrderAudio = playNotificationAudio('playBlankAudioLoop');
    newOrderAudio.volume = 0;
    setTimeout(() => {
        newOrderAudio.volume = 1;
    }, 2000);
}

export const playNotificationAudio = (caller: string) => {
    console.log('📣📣📣playNotificationAudio📣📣📣', caller);
    const audio = document.getElementById('notification-audio') as HTMLAudioElement;
    if (audio) {
        audio.currentTime = 0;
        if (import.meta.env.DEV) {
            audio.volume = 0.1;
        }
        audio.play()
            .then(() => {
                console.log('📣📣📣Audio played📣📣📣');
                isAbleToPlayAudio.value = true;
            })
            .catch(() => {
                isAbleToPlayAudio.value = false;
                // console.warn('📣📣📣Audio permission denied📣📣📣');
                // console.error(error);
            });
    }
    return audio;
}


// Watch for orders with "PLACED" status and play notification sounds
export const watchNewOrders = () => {

    watch(hasError, (newVal) => {
        if (newVal) {
            // wait for 3 second to make sure hasError is still true before playing audio
            setTimeout(() => {
                if (hasError.value) {
                    playNotificationAudio('hasError');
                }
            }, 3000);
        }
    });

    setInterval(() => {
        checkNewOrders();
    }, 30_000);
}


let originalTitle = document.title;
let titleInterval: ReturnType<typeof setInterval> | null = null;

export const checkNewOrders = () => {
    const newOrders = Object.values(cachedStoreOrders.value).filter(
        order => order.orderStatus === STORE_ORDER_STATUS_OBJ.PLACED
    );
    // Set up interval only if there are new orders
    if (newOrders.length > 0) {
        // wait 1 second to make sure created orders count is still the same
        setTimeout(() => {
            const newOrders = Object.values(cachedStoreOrders.value).filter(
                order => order.orderStatus === STORE_ORDER_STATUS_OBJ.PLACED
            );
            if (newOrders.length > 0) {
                playNotificationAudio('checkNewOrders');
            }
        }, 1000);
        flashTitle(newOrders.length);
        for (const order of newOrders) {
            showOrderDialog(order);
        }
    } else {
        if (titleInterval) {
            clearInterval(titleInterval);
            titleInterval = null;
            document.title = originalTitle;
        }
    }
}

const flashTitle = (newOrdersCount: number) => {
    if (titleInterval) {
        document.title = originalTitle;
        clearInterval(titleInterval);
    }
    titleInterval = setInterval(() => {
        if (document.title !== originalTitle) {
            document.title = originalTitle;
        } else {
            document.title = `🚨 ${newOrdersCount} new order(s)`;
        }
    }, 2000);
}

